import { Injectable, inject } from '@angular/core';
import { CachedBuildingLabelService, CachedBuildingService, UserResponseWithImage, UserService } from '@cfp/core';
import {
  BuildingBusinessCaseDTO,
  BuildingDetailsDTO,
  BuildingEnergyIndexesDTO,
  BuildingMeasureTableItemDTO,
  BuildingMeasuresListService,
  BuildingsService,
  MeasureListDTO,
  MeasureStatusDTO,
  RoadmapBuildingYearDTO
} from 'csr-asset-app';
import { Observable, forkJoin, mergeMap, of } from 'rxjs';
import { BuildingReportRoadmapInterface } from '../components/building-report-roadmap/building-report-roadmap.interface';

@Injectable({
  providedIn: 'root'
})
export class BuildingReportContentService {
  private readonly buildingMeasuresListService = inject(BuildingMeasuresListService);
  private readonly buildingsService = inject(BuildingsService);
  private readonly cachedBuildingsService = inject(CachedBuildingService);
  private readonly cachedBuildingLabelService = inject(CachedBuildingLabelService);
  private readonly userService = inject(UserService);

  public getBuildingMeasures(buildingId: number): Observable<MeasureListDTO> {
    return this.buildingMeasuresListService.v2BuildingsIdBuildingmeasuresPost({}, buildingId); // todo validate
  }

  public getAllData(
    buildingId?: number,
    buildingPublicSharedId?: string
  ):
    | Observable<[BuildingDetailsDTO, BuildingEnergyIndexesDTO, BuildingBusinessCaseDTO, UserResponseWithImage?]>
    | undefined {
    if (buildingPublicSharedId) {
      // This needs refactoring, we'd rather fetch the buildingId directly after the public-shared-login and pass it along.
      return this.buildingsService.v1PublicBuildingsPublicSharedIdGet(buildingPublicSharedId).pipe(
        mergeMap((building) => {
          return forkJoin([
            of(building),
            this.cachedBuildingLabelService.v2BuildingsIdLabelsGet(building.id),
            this.cachedBuildingsService.v2BuildingsIdBusinesscaseGet(building.id)
          ]);
        })
      );
    } else if (buildingId) {
      return forkJoin([
        this.cachedBuildingsService.v2BuildingsIdGet(buildingId),
        this.cachedBuildingLabelService.v2BuildingsIdLabelsGet(buildingId),
        this.cachedBuildingsService.v2BuildingsIdBusinesscaseGet(buildingId),
        this.userService.get()
      ]);
    }
    return undefined;
  }

  public combineRoadMapBuildingYearAndMeasureList(
    roadmapBuildingYears: RoadmapBuildingYearDTO[],
    measureListObject: MeasureListDTO
  ): BuildingReportRoadmapInterface[] {
    let fieldsToCombine: BuildingMeasureTableItemDTO[] = [];
    if (!roadmapBuildingYears) {
      return [];
    }

    return roadmapBuildingYears
      .map((roadmapBuildingYear: RoadmapBuildingYearDTO) => {
        fieldsToCombine = measureListObject.measureList.filter((measureListItem: BuildingMeasureTableItemDTO) => {
          return (
            roadmapBuildingYear.year !== null &&
            roadmapBuildingYear.year === measureListItem.implementationYear &&
            measureListItem.status !== MeasureStatusDTO.DONE
          );
        });

        roadmapBuildingYear['measureList'] = fieldsToCombine;
        return roadmapBuildingYear;
      })
      .filter((roadmapBuildingYear: BuildingReportRoadmapInterface) => {
        return roadmapBuildingYear.measureList && roadmapBuildingYear.measureList.length > 0;
      });
  }
}
